import image from "../../img/debata2.jpg";
import React from "react";
import { All, Button, LP, PP } from "./Style";
export default function samo() {
  return (
    <All>
      <LP zrodlo={image}></LP>
      <PP>
        <h1>Film na debatę szkolną</h1>
        <p>
          Film użyty jako materiał otwierający debatę szkolną pt."Samochody
          elektryczną są przyszłością motoryzacji"
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://youtu.be/-MNhXgyjSxg"
        >
          <Button>Zobacz</Button>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/zstiomechaniktg/posts/pfbid0pJFLV4eCNDjhwRdnBVTzrp6xfuHktrtz34VuT5vLYGkXHRSTRDZDZA3m9wCNBNZel"
        >
          <Button>Zdjęcia z debaty</Button>
        </a>
      </PP>
    </All>
  );
}
